package com.exura.pages.planCreator.components

import com.exura.features.plandefinition.domain.model.collection.Collection
import com.exura.features.plandefinition.domain.model.series.BaseSeries

data class IndexedSeries(
    val series: BaseSeries<*>,
    val collectionIndex: Int?,
    val seriesIndex: Int,
    val collection: Collection? = null
) {
    val isFromCollection: Boolean = collectionIndex != null

    fun toUrlIdentifier(): Pair<Int?, Int> = collectionIndex to seriesIndex

    companion object {
        fun fromUrlIdentifier(
            collectionIndex: Int?,
            seriesIndex: Int,
            flattenedSeries: List<IndexedSeries>
        ): IndexedSeries? {
            return flattenedSeries.find {
                it.collectionIndex == collectionIndex && it.seriesIndex == seriesIndex
            }
        }
    }
}

sealed class FlattenedItem {
    data class CollectionHeader(
        val collection: Collection,
        val collectionIndex: Int
    ) : FlattenedItem()

    data class SeriesItem(
        val indexedSeries: IndexedSeries
    ) : FlattenedItem()
}

enum class SeriesGroupingMode {
    GROUPED,
    UNGROUPED
}
